import { useAttendeeStatus } from "amazon-chime-sdk-component-library-react";
import { getInitials } from "../../../utils/chimeHelper";
import { Tooltip } from "@mui/material";
import images from "../../../assets/images";
import { useChimeMeeting } from "../../../Chime/ChimeMeetingContext";

interface ParticipantCardProps {
    participant: any;
    isHostParticipant?: boolean;
    isHandRaised: boolean;
}

const ParticipantCard: React.FC<ParticipantCardProps> = ({ participant, isHostParticipant = false, isHandRaised = false }) => {
    const { ParticipantMuteIcon, ParticipantUnMuteIcon, ParticipantVideoOffIcon,  ParticipantVideoOnIcon, ParticipantRaiseHand } = images;
    const { muted, videoEnabled } = useAttendeeStatus(participant.chimeAttendeeId);
    const { muteParticipant, isHost } = useChimeMeeting();

    return (
        <div className={isHostParticipant ? 'stickyCell' : 'participantCard'}>
            <div className='leftSideOfCard'>
                <div className='avatarStyle'>{getInitials(participant.name)}</div>
                <div className='usernameContainerStyle'>
                    <Tooltip title={participant.name} disableHoverListener={false}>
                        <span className='usernameStyle'>{participant.name}</span>
                    </Tooltip>
                    {isHostParticipant && <span className='hostStyle'>(Host)</span>}
                </div>
            </div>
            <div className='rightSideOfCard'>
                <img src={ParticipantRaiseHand} className={isHandRaised ? 'raiseHandStyle' : 'raiseHandHidden'} alt="raiseHandIcon"/>
                <div className="imageContainer" style={{ cursor: (isHost && !muted) ? "pointer" : "default" }} onClick={() => (isHost && !muted) ? muteParticipant(participant.chimeAttendeeId) : ""}>
                    <img src={muted ? ParticipantMuteIcon : ParticipantUnMuteIcon} className='micIconStyle' alt="muteIcon"/>
                </div>
                <img src={videoEnabled ? ParticipantVideoOnIcon : ParticipantVideoOffIcon} className={videoEnabled ? 'videoIconStyle':'videoOffIconStyle'} alt="videoIcon"/>
            </div>
        </div>
    );
};

export default ParticipantCard;
